module.exports = __webpack_public_path__ + "img/09.04de8a0c.png";